import React, { useCallback } from 'react';

import { createEcommerceDiscoveryBox, createModifyCartEvent, useTrackModifyCartEvent } from '../../../ecommerce';
import { IDiscoveryBox } from '../../../model';
import { useDeleteDiscoveryBoxAwaitable } from '../../../services';
import { CartActions, ECartActions } from '../model';

export const useRemoveDiscoveryBox = (dispatch: React.Dispatch<CartActions>) => {
  const { request } = useDeleteDiscoveryBoxAwaitable();
  const trackModifyCartEvent = useTrackModifyCartEvent();

  return useCallback(
    async (data: number, discoveryBox: IDiscoveryBox) => {
      const result = await request({ itemId: data });

      if (result) {
        dispatch({
          actionType: ECartActions.REMOVE_DISCOVERY_BOX,
          payload: {
            products: result.data.products,
            discoveryBox: result.data.serviceItems.discoveryBox,
            pricesSummary: result.data.pricesSummary,
          },
        });

        trackModifyCartEvent({
          ...createModifyCartEvent(1, 0),
          product: createEcommerceDiscoveryBox(discoveryBox),
        });
      }
    },
    [dispatch, request, trackModifyCartEvent],
  );
};
